
import ReactModal from "react-modal";
import { useGlobalContext } from "../../context";
import React, { useEffect } from "react";
import DoneIcon from "@mui/icons-material/Done";

function UserUpdate() {

    const {
        openUserUpdate,
        setOpenUserUpdate
    } = useGlobalContext()

    useEffect(() => {
        if (openUserUpdate) {
            setTimeout(() => {
                setOpenUserUpdate(false);
            }, 2000)
        }
    }, [openUserUpdate]);

    return(
        <ReactModal
            isOpen={ openUserUpdate }
            style={{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    zIndex: 300,
                },
                content: {
                    width: "90%",
                    top: "5px",
                    maxWidth: '580px',
                    maxHeight: "250px",
                    height: "85vh",
                    border: 'none',
                    margin: "auto",
                    left: "5%",
                    borderRadius: "10px",
                    background: 'white',
                    WebkitOverflowScrolling: 'touch',
                    outline: 'none',
                    boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                    overflowY: "auto",
                }
            }}
        >
            <div className="deleteUserBox">
                <DoneIcon
                    style = {{
                        margin: "50px 41% 0 40%",
                        fontSize: "60px",
                        color: "green"
                    }}
                />
                <h3
                    style = {{
                        margin: "30px 25%",
                        fontSize: "30px",
                        color: "green",
                        fontWeight: "700",
                        fontFamily: "Verdana"
                    }}
                >
                    Update
                </h3>
            </div>
        </ReactModal>
    )
}

export default UserUpdate